import { mimeTypes } from '@/core/constants/mimeTypes';
export default {
  methods: {
    saveFileToDevice(file, filename, extension) {
      const date = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

      const blob = new Blob([file], {
        type: mimeTypes[extension] || mimeTypes.generic,
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}_${date}.${extension}`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url); // cleanup
    },
  },
};
